import { render, staticRenderFns } from "./FormFinancial.vue?vue&type=template&id=96c084ce"
import script from "./FormFinancial.vue?vue&type=script&lang=js"
export * from "./FormFinancial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports